export interface TimeProps {
  date: Date;
}

export default function Time({ date }: TimeProps) {
  return <time dateTime={date.toISOString()}>{date.toUTCString()}</time>;
}
